import { canBulkCommissionAction } from "../../../utilis/invoicePermissionHelpers";
import {
  filterApplicationsEligibleForBulkAction,
  isRowEligibleForBulkAction,
} from "./commissionRowActionEligibility";

/** Actions offered per commission queue tab (order matters in UI). */
const ACTIONS_BY_VIEW = {
  active: ["mark_completed", "discontinue"],
  exceptions_reconciliation: ["reactivate", "submit_final_review"],
  completed: ["submit_final_review", "revert_completed"],
  final_review: ["approve_final_review", "return_final_review"],
  all: [
    "mark_completed",
    "discontinue",
    "reactivate",
    "revert_completed",
    "submit_final_review",
    "approve_final_review",
    "return_final_review",
  ],
};

export const COMMISSION_BULK_ACTION_META = {
  mark_completed: {
    id: "mark_completed",
    label: "Mark as completed",
    confirmTitle: "Mark selected as completed?",
    confirmTone: "success",
  },
  discontinue: {
    id: "discontinue",
    label: "Mark as discontinued",
    confirmTitle: "Mark selected as discontinued?",
    confirmTone: "danger",
    requiresDiscontinueForm: true,
  },
  reactivate: {
    id: "reactivate",
    label: "Restore to active",
    confirmTitle: "Restore selected to active?",
    confirmTone: "primary",
  },
  revert_completed: {
    id: "revert_completed",
    label: "Restore to previous tab",
    confirmTitle: "Restore selected to previous tab?",
    confirmTone: "primary",
  },
  submit_final_review: {
    id: "submit_final_review",
    label: "Send for final review",
    confirmTitle: "Send selected for final review?",
    confirmTone: "primary",
  },
  approve_final_review: {
    id: "approve_final_review",
    label: "Approve and close",
    confirmTitle: "Approve and close selected?",
    confirmTone: "success",
  },
  return_final_review: {
    id: "return_final_review",
    label: "Restore from final review",
    confirmTitle: "Restore selected from final review?",
    confirmTone: "primary",
  },
  remove_from_commissionable: {
    id: "remove_from_commissionable",
    label: "Move to General Report",
    confirmTitle: "Move selected to General Report?",
    confirmTone: "danger",
  },
};

/**
 * @param {{ commissionView?: string, activeReport?: string, selectedApplications?: object[] }} params
 */
export function getVisibleBulkCommissionActions({
  commissionView = "active",
  activeReport = "commission",
  selectedApplications = [],
} = {}) {
  if (activeReport !== "commission") {
    return [];
  }

  const view = commissionView || "active";
  const actionIds = ACTIONS_BY_VIEW[view] || ACTIONS_BY_VIEW.active;

  const context = { activeReport, commissionView: view };

  const withRemove = canBulkCommissionAction("remove_from_commissionable")
    ? [...actionIds, "remove_from_commissionable"]
    : actionIds;

  const uniqueIds = [...new Set(withRemove)];

  return uniqueIds
    .filter((id) => canBulkCommissionAction(id))
    .map((id) => {
      const eligible = filterApplicationsEligibleForBulkAction(
        selectedApplications,
        id,
        context,
      );
      return {
        ...COMMISSION_BULK_ACTION_META[id],
        eligibleCount: eligible.length,
        eligibleApplications: eligible,
      };
    });
}

export function countEligibleForBulkAction(
  applications,
  actionId,
  context,
) {
  return filterApplicationsEligibleForBulkAction(applications, actionId, context)
    .length;
}

export { isRowEligibleForBulkAction };
